const styles = theme => ({
  bannerBG: {
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 48%, ${theme.palette.secondary.main} 52%)`
  },
  btn: {
    display: "inline-block",
    padding: "0 5px",
    lineHeight: 0,
    '& img': {
      display: 'block',
      width: '100%',
      height: 'auto',
    }
  },
  bannerLink: {
    display: 'block',
    lineHeight: 0,
  },
  mAuto: {
    margin: "0 auto",
  }
});

export default styles;